export default __webpack_public_path__ + "static/setFilter-c85179ffae51b23d79ac078cf7f8e12e.gif";